module.exports = __webpack_public_path__ + "static/parts-ec34e0c1324940a35b32ef339e10c30d.png";